import { render, staticRenderFns } from "./BaseLabel.vue?vue&type=template&id=5e5c223b&scoped=true&functional=true&"
import script from "./BaseLabel.vue?vue&type=script&lang=ts&"
export * from "./BaseLabel.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLabel.vue?vue&type=style&index=0&id=5e5c223b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5e5c223b",
  null
  
)

export default component.exports